import { render, staticRenderFns } from "./PSimilarUserProfileCassetteList.vue?vue&type=template&id=413a4263&"
import script from "./PSimilarUserProfileCassetteList.vue?vue&type=script&lang=ts&"
export * from "./PSimilarUserProfileCassetteList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports